import { SET_ERROR } from "../../types";

const initialState = { error: "{}" };

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_ERROR:
            return {
                ...state,
                error: payload
            };
        default:
            return state;
    }
}